import React from 'react';
import { Currency } from 'src/components/currency';
import { type CurrencyType } from 'src/types/currency';
import { type getTranslationFn } from 'src/utils/get-translation-fn';

export const getSplitYourPurchaseText = (
  installmentsCount: number,
  hasMurabaha: boolean,
  t: ReturnType<typeof getTranslationFn>,
  currency: CurrencyType
) => {
  const currencyMap = { currency: () => <Currency currency={currency} /> };

  if (hasMurabaha) {
    return installmentsCount < 11
      ? t(
          'split_your_purchase_in_up_to_few',
          { installmentsCount },
          currencyMap
        )
      : t(
          'split_your_purchase_in_up_to_other',
          { installmentsCount },
          currencyMap
        );
  }

  return installmentsCount < 11
    ? t(
        'paid_plans.split_your_purchase_few',
        { installmentsCount },
        currencyMap
      )
    : t(
        'paid_plans.split_your_purchase_other',
        { installmentsCount },
        currencyMap
      );
};
